export default __webpack_public_path__ + "static/media/scroll-down-arrow.245c81ca.svg";